import * as Sentry from "@sentry/react";

const { REACT_APP_SENTRY_DSN, REACT_APP_SENTRY_ENV } = window;

Sentry.init({
  environment: REACT_APP_SENTRY_ENV,
  release: process.env.REACT_APP_GIT_HASH,
  dsn: REACT_APP_SENTRY_DSN,
  integrations: [Sentry.browserProfilingIntegration()],
  tracesSampleRate: 0.025,
  beforeSend(event): Sentry.Event {
    // Remove JWT from url before sending to sentry
    if (event.request?.url) {
      event.request.url = event.request.url.split("#")[0];
    }
    return event;
  },
});

export default Sentry;
